import Station from '@/models/valorization/filter/Station';
import Perimeter from '@/models/valorization/filter/Perimeter';
import Range from '@/models/valorization/filter/Range';
import slugify from '@/methods/slugify';
import Protocol from '@/models/valorization/filter/Protocol';

export default class Filter {
  public stations: Station[] = [];

  public protocols: Protocol[] = [
    {
      id: slugify('Observatoire Faune'),
      name: 'Observatoire Faune',
      group: slugify('Observatoire'),
      valorizations: [
        // {
        //   id: slugify('Observatoire Faune Tableaux header'),
        //   group: 'Tableaux',
        //   name: 'Tableau',
        //   component: '',
        //   type: 'header',
        // },
        {
          id: slugify('Liste des espèces par groupe faunistique'),
          group: 'Tableaux',
          name: 'Liste des espèces par groupe faunistique',
          component: 'ListOfSpeciesByFaunisticGroupTable',
          type: 'item',
        },
        {
          id: slugify('Nombre d\'espèces'),
          name: 'Nombre d\'espèces',
          group: 'Tableaux',
          component: 'NecessaryRequestsTable',
          type: 'item',
        },
        // {
        //   id: slugify('Observatoire Faune Graphes divider'),
        //   group: 'Graphes',
        //   name: 'Graphes',
        //   component: '',
        //   type: 'divider',
        // },
        // {
        //   id: slugify('Observatoire Faune Graphes header'),
        //   group: 'Graphes',
        //   name: 'Graphes',
        //   component: '',
        //   type: 'header',
        // },
        {
          id: slugify('Nombre annuel cumulé'),
          name: 'Nombre annuel cumulé',
          group: 'Graphes',
          component: 'AnnualCumulativeNumberChart',
          type: 'item',
        },
        {
          id: slugify('Statut de menace'),
          group: 'Graphes',
          name: 'Statut de menace',
          component: 'StatusOfThreatChart',
          type: 'item',
        },
      ],
      groups: [
        {
          id: 'amphibian',
          name: 'Amphibiens',
        },
        {
          id: 'chiropteres',
          name: 'Chiroptères',
        },
        {
          id: 'coleopteres',
          name: 'Coléoptères',
        },
        {
          id: 'lepidopteres',
          name: 'Lépidoptères',
        },
        {
          id: 'mammiferes_hors_chiro',
          name: 'Mammifères terrestres',
        },
        {
          id: 'reptiles',
          name: 'Reptiles',
        },
        {
          id: 'odonates',
          name: 'Odonates',
        },
        {
          id: 'orthopteres',
          name: 'Orthoptères',
        },
        {
          id: 'avifaune',
          name: 'Oiseaux',
        },
      ],
    },
    {
      id: slugify('Observatoire Flore'),
      name: 'Observatoire Flore',
      group: slugify('Observatoire'),
      valorizations: [
        // {
        //   id: slugify('Observatoire Flore Tableaux header'),
        //   group: 'Tableaux',
        //   name: 'Tableaux',
        //   component: '',
        //   type: 'header',
        // },
        {
          id: slugify('Bilan flore patrimoniale'),
          group: 'Tableaux',
          name: 'Bilan flore patrimoniale',
          component: 'PatrimonialFloraBalanceTable',
          type: 'item',
        },
        // {
        //   id: slugify('Observatoire Flore Fiches divider'),
        //   group: 'Fiches',
        //   name: 'Fiches',
        //   component: '',
        //   type: 'divider',
        // },
        // {
        //   id: slugify('Observatoire Flore Fiches header'),
        //   group: 'Fiches',
        //   name: 'Fiches',
        //   component: '',
        //   type: 'header',
        // },
        {
          id: slugify('Fiche Patrimoniale 1'),
          group: 'Fiches',
          name: 'Fiche Patrimoniale 1',
          component: 'PatrimonialSheetOneSheet',
          type: 'item',
        },
        {
          id: slugify('Fiche Patrimoniale 2'),
          group: 'Fiches',
          name: 'Fiche Patrimoniale 2',
          component: 'PatrimonialSheetTwoSheet',
          type: 'item',
        },
        // {
        //   id: slugify('Observatoire Flore Graphes divider'),
        //   group: 'Graphes',
        //   name: 'Graphes',
        //   component: '',
        //   type: 'divider',
        // },
        // {
        //   id: slugify('Observatoire Flore Graphes header'),
        //   group: 'Graphes',
        //   name: 'Graphes',
        //   component: '',
        //   type: 'header',
        // },
        {
          id: slugify('Nombre d\'observatios géo-localisées'),
          group: 'Graphes',
          name: 'Nombre d\'observatios géo-localisées',
          component: 'NumberOfGeoLocalizedObservationsChart',
          type: 'item',
        },
        {
          id: slugify('Evolution des connaissances floristiques'),
          group: 'Graphes',
          name: 'Evolution des connaissances floristiques',
          component: 'EvolutionOfFloristicKnowledgeChart',
          type: 'item',
        },
        {
          id: slugify('Statuts de menace'),
          group: 'Graphes',
          name: 'Statuts de menace',
          component: 'ThreatModesChart',
          type: 'item',
        },
      ],
      groups: [],
    },
  ];

  public perimeters: Perimeter[] = [
    {
      id: slugify('Données de l\'année'),
      name: 'Données de l\'année',
      range: {
        start: new Date().getFullYear() + '-01-01',
        end: new Date().getFullYear() + '-12-31',
      },
    },
    {
      id: slugify('Données de toutes les années des stations'),
      name: 'Données de toutes les années des stations',
      range: {
        start: '1900-01-01',
        end: '2900-12-31',
      },
    },
    {
      id: slugify('Données entre 2 dates'),
      name: 'Données entre 2 dates',
      range: {
        start: new Date().getFullYear() + '-01-01',
        end: new Date().getFullYear() + '-12-31',
      },
    },
  ];

  public perimeterRange: Range[] = [];
}
